import type { ReactNode } from 'react';
import styled from '@emotion/styled';
import { tokens, Button } from '@hotjar/hotsauce';

const Container = styled.div`
  padding: ${tokens.spacer.x1} ${tokens.spacer.x2} ${tokens.spacer.x2} ${tokens.spacer.x2};
  position: relative; // This position: relative to make sure the footer is always on top of the body in case of animation (cf clicked filter)
`;

interface GenericFilterFooterProps {
  isDisabled?: boolean;
  footerMessage?: ReactNode;
}

export function GenericFilterFooter({
  isDisabled,
  footerMessage,
}: GenericFilterFooterProps): JSX.Element {
  return (
    <>
      <Container>
        <Button type="submit" isDisabled={isDisabled} size="s">
          Apply
        </Button>
      </Container>
      {footerMessage != null && footerMessage}
    </>
  );
}
